export default __webpack_public_path__ + "428d9bac0898d506c33d3f99b1912306.svg";